// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Import Pages, Layouts, and Protection
import LoginPage from "./pages/LoginPage";
import CreatorAuthPage from "./pages/CreatorAuthPage";
import LandingPage from "./pages/LandingPage";
import AppLayout from "./components/layout/AppLayout";
import { useLayout } from "./context/LayoutContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";

// Import Portal Routers
import FanRoutes from "./portals/fan/FanRoutes";
import CreatorRoutes from "./portals/creator/CreatorRoutes";
import AdminRoutes from "./portals/admin/AdminRoutes";

function App() {
  const { layoutMode } = useLayout();
  
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/creator-auth"
        element={<CreatorAuthPage />}
      />

      {/* Protected Portal Routes */}
      <Route
        path="/fan/*"
        element={
          <ProtectedRoute allowedRoles={["fan", "creator", "admin"]}>
            <AppLayout variant="mobile">
              <FanRoutes />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute allowedRoles={["creator"]}>
            <AppLayout variant={layoutMode === "mobile" ? "mobile" : "wide"}>
              <CreatorRoutes />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AppLayout variant={layoutMode === "mobile" ? "mobile" : "wide"}>
              <AdminRoutes />
            </AppLayout>
          </ProtectedRoute>
        }
      />

      {/* Default redirect for any other path */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
